import { CustomGoal, getAnnualReturnUsingRiskScore } from '../../../goals';
import { colorsByGoalType } from '../../../goals/colors';
import { getProgressUsingTargetAmount } from '../helpers';
import { BaseGoalConfig } from './types';

export const CUSTOM: BaseGoalConfig<CustomGoal> = {
    iconName: 'GoalCustom',
    color: colorsByGoalType['CUSTOM'].primary,
    defaultName: 'Custom goal',
    getDescription: () => 'Whatever you can dream up, make it come true.',
    group: 'INVEST',
    blogLink: null,
    getAnnualReturn: getAnnualReturnUsingRiskScore,
    getProgress: (config) => getProgressUsingTargetAmount(config),
};
